'use strict';

// file-dropzone/upload.js — загрузка файлов на сервер через AJAX (делегированная)

let UPLOAD_URL = '/dashboard/file-dropzone/upload';

jQuery(document).on('change', '.file-dropzone-input', function () {
    let fileInput = jQuery(this);
    let component = fileInput.closest('.file-dropzone-component');
    let files = Array.from(fileInput[0].files);
    if (!files.length) return;

    fileInput.val('');

    let field = component.data('field') || '';

    // Лимит количества файлов (data-max): не даём выбрать больше, чем осталось мест.
    let max = parseInt(component.data('max'), 10);
    if (!isNaN(max) && component.find('.file-dropzone-preview .file-dropzone-item').length + files.length > max) {
        if (typeof window.showToast === 'function') {
            window.showToast('Можно добавить не более ' + max + ' файлов', 'danger');
        }
        return;
    }

    let progress = component.find('.file-dropzone-progress');
    let progressBar = progress.find('.progress-bar');

    progress.removeClass('d-none');
    progressBar.css('width', '0%');

    let formData = new FormData();
    formData.append('files', new Blob([]));
    files.forEach(function (file) {
        formData.append('files[]', file, file.name);
    });
    if (field) {
        formData.append('field', field);
    }
    if (component.data('multiple')) {
        formData.append('multiple', 1);
    }

    jQuery.ajax({
        url: component.data('upload-url') || UPLOAD_URL,
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        xhr: function () {
            let xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', function (e) {
                if (e.lengthComputable) {
                    progressBar.css('width', Math.round((e.loaded / e.total) * 100) + '%');
                }
            });
            return xhr;
        },
        success: function (response) {
            if (response.html) {
                component.find('.file-dropzone-preview').append(response.html);
            }
        },
        error: function (xhr) {
            let msg = 'Ошибка загрузки файлов';
            if (xhr.responseJSON && xhr.responseJSON.message) {
                msg = xhr.responseJSON.message;
            }
            if (typeof window.showToast === 'function') {
                window.showToast(msg, 'danger');
            }
        },
        complete: function () {
            progress.addClass('d-none');
            progressBar.css('width', '0%');
        }
    });
});